import React from "react";
import { toast } from "react-toastify";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useCreateGivenCans } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { useProducts } from "../../products/hooks";

interface IProps {
  productId?: number;
  customerId?: number;
  onCompleted: () => void;
}

export const GivenCansForm: React.FC<IProps> = ({ productId, customerId, onCompleted }) => {
  const { data: productsData } = useProducts({ where: {}, limit: 100, offset: 0 });
  const { form, submit, loading } = useCreateGivenCans({
    defaultValues: { productId, customerId, comment: "" },
    onCompleted: () => {
      toast.success("La distribution a été enregistrée avec succès");
      form.reset({ productId, customerId, comment: "" });
      onCompleted();
    },
  });

  return (
    <div className="flex flex-wrap gap-3 items-end">
      {!productId && (
        <Select
          label="Produit"
          className="w-full"
          {...form.register("productId", { required: true, valueAsNumber: true })}
        >
          <option value="">-</option>
          {productsData?.products?.results?.map((product) => (
            <option key={product.id} value={product.id}>
              {product.name}
            </option>
          ))}
        </Select>
      )}
      {!customerId && (
        <CustomerSelectSearch form={form} name="customerId" label="Client (optionnel)" />
      )}
      <Input
        label="Quantité"
        type="number"
        className="w-full"
        {...form.register("quantity", { required: true, valueAsNumber: true })}
        placeholder="1"
      />
      <Textarea
        label="Commentaire (optionnel)"
        className="w-full"
        {...form.register("comment")}
        placeholder="Échantillon commercial, distribution promotionnelle..."
      />
      <Button onClick={submit} loading={loading} disabled={loading}>
        Enregistrer la distribution
      </Button>
    </div>
  );
};
